import api from "../services/api";

// Fetch reviews with optional filtering by rating_type or driver_id
export const fetchReviews = async (
  rating_type = null,
  driver_id = null,
  page = 1,
  size = 50
) => {
  try {
    const params = { page, size };

    // Add filter parameters only if they are provided
    if (rating_type) {
      params.rating_type = rating_type;
    }
    if (driver_id) {
      params.driver_id = driver_id;
    }

    const response = await api.get("/review-management/reviews/", {
      params,
    });

    if (response.status === 200) {
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching reviews:", error.message || error);
    const errorMessage =
      error.response?.data?.detail || error.message || "Failed to fetch reviews";
    return { error: errorMessage };
  }
};
